export default __webpack_public_path__ + "static/media/youtube.71aa7021.svg";